<template functional>
  <footer class="the-footer flex-wrap justify-center" :class="classes">
    <span>Copyright &copy; {{ new Date().getFullYear() }} All rights reserved</span>
  </footer>
</template>

<script>
export default {
  name: "the-footer",
  props: {
    classes: {
      type: String,
    },
  },
};
</script>
